export default "<ng-template #container></ng-template>";